// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { type Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import type Enums from '../Enums';

export class TruckingTypeSummary {
  readonly id: string;
  readonly name: string;
  readonly description: string | null;
  readonly plants: string | null;
  readonly categories: string;
  readonly rateUnit: Enums.Unit | null;
  readonly defaultHaulRate: Currency | null;
  readonly defaultHaulCost: Currency | null;
  readonly minimumHaulCharge: number | null;
  readonly loadCapacity: string | null;
  readonly loadCapacityUnit: Enums.Unit | null;
  readonly isArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.description = data.description === undefined ? null : data.description;
    this.plants = data.plants === undefined ? null : data.plants;
    this.categories = data.categories === undefined ? '' : data.categories;
    this.rateUnit = data.rateUnit === undefined ? null : data.rateUnit;
    this.defaultHaulRate =
      (data.defaultHaulRate ?? null) === null ? null : NewCurrency(data.defaultHaulRate);
    this.defaultHaulCost =
      (data.defaultHaulCost ?? null) === null ? null : NewCurrency(data.defaultHaulCost);
    this.minimumHaulCharge = data.minimumHaulCharge === undefined ? null : data.minimumHaulCharge;
    this.loadCapacity = data.loadCapacity === undefined ? null : data.loadCapacity;
    this.loadCapacityUnit = data.loadCapacityUnit === undefined ? null : data.loadCapacityUnit;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
  }

  static zero(): TruckingTypeSummary {
    const zeroValues: ExcludeMethodsDeep<TruckingTypeSummary> = {
      id: NIL_UUID,
      name: '',
      description: null,
      plants: null,
      categories: '',
      rateUnit: null,
      defaultHaulRate: null,
      defaultHaulCost: null,
      minimumHaulCharge: null,
      loadCapacity: null,
      loadCapacityUnit: null,
      isArchived: false,
    };
    return new TruckingTypeSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type TruckingTypeSummaryWireFormat = {
  id: string;
  name: string;
  description: string | null;
  plants: string | null;
  categories: string;
  rateUnit: string | null;
  defaultHaulRate: CurrencyWireFormat | null;
  defaultHaulCost: CurrencyWireFormat | null;
  minimumHaulCharge: number | null;
  loadCapacity: string | null;
  loadCapacityUnit: string | null;
  isArchived: boolean;
};

type NewTruckingTypeSummaryProps = PartialDeep<TruckingTypeSummary, { recurseIntoArrays: true }>;
export const NewTruckingTypeSummary: (props: NewTruckingTypeSummaryProps) => TruckingTypeSummary = (
  props,
) => new TruckingTypeSummary(props);

type NewTruckingTypeSummaryFromWireFormatProps = PartialDeep<
  TruckingTypeSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewTruckingTypeSummaryFromWireFormat: (
  props: NewTruckingTypeSummaryFromWireFormatProps,
) => TruckingTypeSummary = (props) => new TruckingTypeSummary(props);
